<template lang="pug">
    div
        template(v-if="$scopedSlots.sort")
            template(v-for="({ label }, index) in sorts")
                div(@click="activeSort = index")
                    slot(name="sort" :label="label" :isActive="index === activeSort")

        template(v-else)
            div(class="select is-small")
                select(v-model="activeSort")
                    template(v-for="({ label }, index) in sorts")
                        option(:value="index") {{ label }}
</template>

<script>
import SearchComponent from './component'

export default {
    extends: SearchComponent,
    computed: {
        sorts() {
            return this.$searchContext.state.sorts
        },
        activeSort: {
            get() {
                return this.$searchContext.state.currentSort
            },
            set(index) {
                this.updateSort(index)
            },
        },
    },
    methods: {
        updateSort(index) {
            this.$searchContext.setSort(index)

            const { mod } = this.$route.query

            const routeObj = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...(mod && { mod }),
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(routeObj)
        },
    },
}
</script>
